import { render } from "./AppStore.vue?vue&type=template&id=274ea08c&scoped=true&ts=true"
import script from "./AppStore.vue?vue&type=script&lang=ts"
export * from "./AppStore.vue?vue&type=script&lang=ts"

import "./AppStore.vue?vue&type=style&index=0&id=274ea08c&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274ea08c"]])

export default __exports__